import { render, staticRenderFns } from "./SessionDetailHeader.vue?vue&type=template&id=5dca2d31&scoped=true&"
import script from "./SessionDetailHeader.vue?vue&type=script&lang=js&"
export * from "./SessionDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailHeader.vue?vue&type=style&index=0&id=5dca2d31&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca2d31",
  null
  
)

export default component.exports